<template>
    <div class="card shadow-sm mb-5 p-5 card-flush overflow-hidden h-md-100">
      <button v-if="remove"
          type="button"
          class="btn-close position-absolute top-0 end-0 mt-2 me-4"
          aria-label="Remove"
          @click="remove"/>

        <div class="card-header">
          <div class="card-title">
              <h5 style="text-align: start">{{ title }}</h5>
          </div>
          
        </div>
        <Loader :is-loading="loading">
          <div class="card-body d-flex text-center justify-content-center flex-column px-0">
            <div v-if="!saleProducts?.length" class="text-center">
              <img src="@/assets/media/pos/Empty2.png" alt="" class="mw-100 h-150px" />
              <div class="text-gray-400 fs-4 fw-bold">{{ $t('no_data_found') }}</div>
              <div class="text-gray-700 fs-4 fw-bold">{{ $t('statistics.sale_products') }}</div>
            </div>
            <div v-if="saleProducts?.length" class="p-5">
              <h5 style="margin-bottom: 10px; text-align: start">{{ $t('statistics.sale_products') }} ({{ defaultCurrency?.symbol }})</h5>
              <canvas id="kt_chartjs_products" class="mh-200px"></canvas>
            </div>
          </div>
        </Loader>
    </div>  
</template>
<script setup>
import {  shallowRef,onMounted, ref,  watch} from 'vue';
import { useStore } from 'vuex';
import { computed } from 'vue';
import Loader from '@/components/Loader.vue';

const store = useStore()

const props = defineProps({
  id:{type: String, required: true},
  title:{type: String, required: true},
  loading:{type: Boolean, default: false},
  loadStats:{type: Function, required: true},
  remove:{type: Function},
  start: { type: Date, required: false },
  end: { type: Date, required: false },

})
  
const query = ref({
    start_date: '',
    end_date: '',
    
})

const saleProducts = ref([])
const chartProductRef = shallowRef(null)

const defaultCurrency = computed(() => store.getters['company/getCompanyCurrency'])

watch(() => query.value, () => {
  if (query.value.start_date && query.value.end_date) {
    loadData();
  }
}, {deep: true})

watch(() => [props.start, props.end], () => {
 if(props.start) query.value.start_date = props.start
 if(props.end) query.value.end_date = props.end
})


function loadData(){
  if (!query.value.start_date || !query.value.end_date) {
    console.warn("Dates non définies, loadData ignorée");
    return;
  }
  if(isSafe(query.value.start_date) && isSafe(query.value.end_date)){
     Promise.all([
        props.loadStats({id:props.id,startDate: query.value.start_date, endDate: query.value.end_date}).then((res) => {
          saleProducts.value = res?.data?.top_products || res?.response?.data;


        }),  
    ]).then(() => {
      chartProducts()
    }) 
  }
    
}

function chartProducts(){
  let ctx = document.getElementById('kt_chartjs_products');

  if(ctx) {
    if(Chart.getChart("kt_chartjs_products")) {
      Chart.getChart("kt_chartjs_products")?.destroy()
    }
    let context = ctx.getContext('2d');

    let products = [];
    let colors = ["rgba(54, 162, 235, 1)", "rgba(75, 192, 192, 1)", "rgba(153, 102, 255, 1)", "rgba(54, 162, 235, 1)", "rgba(75, 192, 192, 1)"]

    saleProducts.value.map((product, index) => {
      products.push({
        label: product.name,
        data: [{x: product.percentage, y: product.amount, r: 15}],
        backgroundColor: colors[index],
        borderColor: colors[index],
      })
    })

    if(context){
      let fontFamily = KTUtil.getCssVariableValue('--bs-font-sans-serif');

      let config = {
          type: 'bubble',
          data: {
            datasets: products
          },
        options: {
          responsive: true,
          plugins: {
            legend: {
              display: true,
              position: 'bottom',
            },
            tooltip: {
              callbacks: {
                label: function(context) {
                  let label = context.dataset.label || '';
                  if (label) {
                    label += ': ';
                  }
                  label += $formatLocalAmount(context.raw.y) + ' ' + defaultCurrency.value?.symbol;
                  return label;
                }
              }
            },
            datalabels: {
              anchor: 'end',
              align: 'end',
              formatter: function(value, context) {
                return context.dataset.label;
              },
              color: 'black',
              font: {
                weight: 'bold',
              }
            }
          }
        },
        defaults:{
          global: {
            defaultFont: fontFamily
          }
        }
      };

      if (!chartProductRef.value) {
        chartProductRef.value = new Chart(ctx, config);
      }else{
        chartProductRef.value.destroy()
        chartProductRef.value = new Chart(ctx, config);
      }
    }
  } else {
    console.error('Canvas element not found');
  }
}

  
onMounted(() => {
 if(props.start) query.value.start_date = props.start
 if(props.end) query.value.end_date = props.end 
})

function isSafe(date){
  if(!date || date === undefined )
    return false

  return true
}
</script>